import { Field, Input, Select } from '../../../ui/forms';

export function ChecksEditor({
  checks,
  value,
  onChange,
}: {
  checks: string[];
  value: Record<string, { passed: boolean; observation: string }>;
  onChange: (v: Record<string, { passed: boolean; observation: string }>) => void;
}) {
  return (
    <div className="stack sm">
      {checks.map((c) => (
        <div key={c} className="grid-2">
          <Field label={c}>
            {(p) => (
              <Select
                {...p}
                value={value[c]?.passed === undefined ? '' : String(value[c]!.passed)}
                onChange={(e) =>
                  onChange({
                    ...value,
                    [c]: { passed: e.target.value === 'true', observation: value[c]?.observation ?? '' },
                  })
                }
              >
                <option value="">No result</option>
                <option value="true">Passed</option>
                <option value="false">Failed</option>
              </Select>
            )}
          </Field>
          <Field label="Observation">
            {(p) => (
              <Input
                {...p}
                value={value[c]?.observation ?? ''}
                onChange={(e) =>
                  onChange({
                    ...value,
                    [c]: { passed: value[c]?.passed ?? false, observation: e.target.value },
                  })
                }
              />
            )}
          </Field>
        </div>
      ))}
    </div>
  );
}
